import { Dialog, Typography } from '@mui/material';
import ModalTemplate from '../modal/modal-template';
import { useTranslation } from 'react-i18next';

type Types = 'branch' | 'agreement' | 'employee';

interface ConfirmDeletionProps {
  onSubmit: () => void;
  open: boolean;
  onClose: () => void;
  type: Types;
}

const ConfirmDeletion = ({
  onSubmit,
  open,
  onClose,
  type,
}: ConfirmDeletionProps) => {
  const { t } = useTranslation();

  const showMessage = (type: Types) => {
    switch (type) {
      case 'branch':
        return t('settings.confirm_delete_branch');
      case 'employee':
        return t('settings.confirm_delete_employee');
      default:
        return t('settings.confirm_delete_condition');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          maxWidth: 600,
          width: '100%',
        },
      }}
    >
      <ModalTemplate
        onClose={onClose}
        title={t('settings.confirm_delete_title')}
        submitBtnText={t('settings.confirm_delete_button')}
        cancelBtnText={t('settings.cancel')}
        onSubmit={onSubmit}
      >
        <Typography fontSize='1.7rem'>{showMessage(type)}</Typography>
      </ModalTemplate>
    </Dialog>
  );
};

export default ConfirmDeletion;
